<ion-button class = "submit-button" type="submit" (click) = "handleClick()">
  <div class = "submit-text">{{ labelText }}</div>
  <div *ngIf="showIcon" class = "ellipse"><i class = "fas fa-arrow-right"></i></div>
</ion-button>